import { apiClient } from './client'

export interface Room {
  id: number
  project_id: number
  num: string
  name: string
}

export async function getRooms(projectId: number): Promise<Room[]> {
  const response = await apiClient.get(`/api/rooms?project_id=${projectId}`)
  
  // After interceptor fix, response.data contains the actual data
  if (Array.isArray(response.data)) {
    return response.data as Room[]
  }
  
  return []
}

export async function createRoom(roomData: Omit<Room, 'id'>): Promise<Room> {
  const response = await apiClient.post('/api/rooms', roomData)
  
  // After interceptor, response.data is already the room object
  if (response.data && response.data.id) {
    return response.data as Room
  }
  
  throw new Error('Failed to create room')
}

export async function updateRoom(id: number, roomData: Partial<Omit<Room, 'id'>>): Promise<Room> {
  const response = await apiClient.put(`/api/rooms/${id}`, roomData)
  
  // After interceptor, response.data is already the room object
  if (response.data && response.data.id) {
    return response.data as Room
  }
  
  throw new Error('Failed to update room')
}

export async function deleteRoom(id: number): Promise<void> {
  const response = await apiClient.delete(`/api/rooms/${id}`)
  
  // After interceptor, if response.data is undefined but status is 200, deletion succeeded
  // DELETE API returns {success: true, message: 'Room deleted'} without 'data' field
  // Interceptor sets response.data = response.data.data which becomes undefined
  // So we check response status instead
  if (response.status >= 200 && response.status < 300) {
    return
  }
  
  throw new Error('Failed to delete room')
} 